(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsm-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('gsm-finder')) return;

    const slug = (v) => String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    // "0012" -> "12", "#1285" -> "1285", "JCO67" (letter O typed for zero) -> "JC067"
    const bowNumber = (v) => {
      let raw = String(v).trim().toUpperCase().replace(/^#/, '').replace(/[\s.]+/g, '');
      raw = raw.replace(/^(JC|W)([0-9O]+)$/, (_, p, n) => p + n.replace(/O/g, '0'));
      return /^\d+$/.test(raw) ? String(parseInt(raw, 10)) : raw;
    };

    class GsmFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.addEventListener('submit', (e) => this.onSubmit(e));
        this.addEventListener('input', (e) => this.reset(e.target.closest('form')));
        this.addEventListener('change', (e) => this.reset(e.target.closest('form')));
      }

      say(form, text, info) {
        const m = form && form.querySelector('[data-msg]');
        if (!m) return;
        m.textContent = text || '';
        m.classList.toggle('is-info', Boolean(info));
      }

      reset(form) {
        if (!form || form.dataset.busy) return;
        this.say(form, '');
        const slot = form.querySelector('[data-note]');
        if (slot) slot.replaceChildren();
      }

      go(url) {
        window.location.href = url;
      }

      async onSubmit(e) {
        const form = e.target.closest('form[data-door]');
        if (!form) return;
        e.preventDefault();
        const door = form.dataset.door;
        const field = form.querySelector('select, input');

        if (door === 'oneida') {
          if (!field.value) { this.say(form, form.dataset.empty); field.focus(); return; }
          this.go(field.value);
          return;
        }

        if (door === 'serial') {
          const v = field.value.trim().toUpperCase().slice(0, 24);
          if (!v) { this.say(form, form.dataset.empty); field.focus(); return; }
          this.go(this.dataset.finderUrl + '?serial=' + encodeURIComponent(v) + '#serial');
          return;
        }

        if (door === 'gstring') {
          if (form.dataset.busy) return;
          const model = form.querySelector('select').value;
          const input = form.querySelector('input');
          const num = bowNumber(input.value);
          if (!model) { this.say(form, 'Pick G-Rex, Gnat, Pro2G or GSB first: the same number means a different bow on each.'); form.querySelector('select').focus(); return; }
          if (!num) { this.say(form, form.dataset.empty); input.focus(); return; }
          const base = this.dataset.bowUrl.replace(/\/?$/, '/');
          const url = base + slug(model) + '-' + slug(num);
          const btn = form.querySelector('button[type="submit"]');
          const slot = form.querySelector('[data-note]');
          slot.replaceChildren();
          form.dataset.busy = '1';
          btn.setAttribute('aria-busy', 'true');
          this.say(form, form.dataset.checking, true);
          let found = false;
          if (model !== 'GSB') try {
            const opts = { method: 'HEAD', credentials: 'same-origin' };
            if (window.AbortSignal && AbortSignal.timeout) opts.signal = AbortSignal.timeout(10000);
            const res = await fetch(url, opts);
            found = res.ok;
          } catch (err) {
            found = false;
          }
          if (found) { this.go(url); return; }
          delete form.dataset.busy;
          btn.removeAttribute('aria-busy');
          this.say(form, '');
          const tpl = this.querySelector('template[data-notfound]');
          if (tpl) {
            const note = tpl.content.cloneNode(true);
            const name = note.querySelector('[data-nf-name]');
            if (name) name.textContent = model + ' #' + num;
            slot.replaceChildren(note);
          }
        }
      }
    }

    customElements.define('gsm-finder', GsmFinder);

    // Coming back with the Back button: clear any "checking" state left on the page.
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('gsm-finder form[data-busy]').forEach((f) => {
        delete f.dataset.busy;
        const b = f.querySelector('[aria-busy]');
        if (b) b.removeAttribute('aria-busy');
        const m = f.querySelector('[data-msg]');
        if (m) m.textContent = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsm-our-bows"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.gsmBowsReady) return;
    window.gsmBowsReady = true;

    const swatchFrom = (target) => (target instanceof Element ? target.closest('[data-gsm-sw]') : null);

    // Un-hide a color's photo so the browser starts loading it (it stays invisible until picked).
    const prime = (button) => {
      const card = button.closest('[data-gsm-bow]');
      const shot = card && card.querySelector(`[data-gsm-shot="${button.dataset.gsmSw}"]`);
      if (shot && shot.hidden) {
        shot.hidden = false;
        const img = shot.querySelector('img');
        if (img) img.loading = 'eager';
      }
      return { card, shot };
    };

    const onIntent = (event) => {
      const button = swatchFrom(event.target);
      if (button) prime(button);
    };
    document.addEventListener('pointerover', onIntent);
    document.addEventListener('focusin', onIntent);

    document.addEventListener('click', (event) => {
      const button = swatchFrom(event.target);
      if (!button) return;
      const { card, shot } = prime(button);
      if (!card || !shot) return;

      card.querySelectorAll('[data-gsm-sw]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));

      const chip = card.querySelector('[data-gsm-chip]');
      if (chip) {
        chip.style.setProperty('--c1', button.style.getPropertyValue('--c1'));
        chip.style.setProperty('--c2', button.style.getPropertyValue('--c2'));
        const name = chip.querySelector('[data-gsm-chip-name]');
        if (name) name.textContent = button.dataset.name || '';
      }

      card.gsmWant = shot;
      const show = () => {
        if (card.gsmWant !== shot) return;
        card.querySelectorAll('[data-gsm-shot]').forEach((s) => {
          s.classList.remove('was');
          if (s !== shot && s.classList.contains('is-on')) {
            s.classList.remove('is-on');
            s.classList.add('was');
          }
        });
        shot.classList.add('is-on');
        clearTimeout(card.gsmTimer);
        card.gsmTimer = setTimeout(() => {
          card.querySelectorAll('[data-gsm-shot].was').forEach((s) => s.classList.remove('was'));
        }, 450);
      };

      const img = shot.querySelector('img');
      if (!img || img.complete) {
        show();
      } else {
        img.addEventListener('load', show, { once: true });
        img.addEventListener('error', show, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
